module.exports = __webpack_public_path__ + "img/logo_starfounder.e4075947.svg";